// Filters.jsx
import React from 'react';
import { monthUa } from './constants';
import './StatisticaGroupsAttends.css';



const Filters = ({
  years,
  setDistr,
  setSpec,
  selYear,
  selMonth,
  selDist,
  selSpec,
  selAge,
  grFull,
  onYearChange,
  onMonthChange,
  onDistChange,
  onSpecChange,
  onAgeChange,
  onShowData
}) => {
  return (
    <div className="filter-row">
      <div className="row">
        <div className="col-md-2 filter-section">
          <label className="filter-label">Навчальний рік:</label>
          <select 
            className="filter-select" 
            value={selYear} 
            onChange={onYearChange}
          >
            {years.map((elem, index) => (
              <option key={index} value={`${elem._id}:${index}`}>
                {elem._id}/{elem._id + 1}
              </option>
            ))}
          </select>
        </div>

        <div className="col-md-2 filter-section">
          <label className="filter-label">Місяць:</label>
          <select 
            className="filter-select" 
            value={selMonth} 
            onChange={onMonthChange}
          >
            {monthUa.map((el, i) => (
              <option key={i} value={i}>{el}</option>
            ))}
            <option value="none">не обраний</option>
          </select>
        </div>

        <div className="col-md-2 filter-section">
          <label className="filter-label">Район:</label>
          <select 
            className="filter-select" 
            value={selDist} 
            onChange={onDistChange}
          >
            {setDistr.map((dist, index) => (
              <option key={index} value={dist}>{dist}</option>
            ))}
          </select>
        </div>

        <div className="col-md-2 filter-section">
          <label className="filter-label">Спеціалізація:</label>
          <select 
            className="filter-select" 
            value={selSpec} 
            onChange={onSpecChange}
          >
            <option value="all">будь-яка</option>
            {setSpec.map((spec, index) => (
              <option key={index} value={spec}>{spec}</option>
            ))}
          </select>
        </div>

        <div className="col-md-2 filter-section">
          <label className="filter-label">Вікова категорія:</label>
          <select 
            className="filter-select" 
            value={selAge} 
            onChange={onAgeChange}
          >
            <option value="all">всі категорії</option>
            {grFull.map((group, index) => (
              <option key={index} value={group.number}>
                {group.description}
              </option>
            ))}
          </select>
        </div>

        <div className="col-md-2 filter-section">
          <label className="filter-label">&nbsp;</label>
          <button className="filter-button" onClick={onShowData}>
            Показати
          </button>
        </div>
      </div>
    </div>
  );
};

export default Filters;